import { IbundleData } from '../interfaces';

export const initialState: any = [];


